import { atom } from 'jotai';

export const copyEventsEdtModalAtom = atom<
  | {
      date: Date;
    }
  | undefined
>(undefined);
